// Set Auth Token Function

// Path: src/utils/setAuthToken.ts

// Compare this snippet from src/features/auth/auth_slice.ts:

import API from "../helpers/network/http";

const setAuthToken = (token: string | null) => {
    if (token) {
        // Apply authorization token to every request if logged in
        API.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        // Delete auth header
        delete API.defaults.headers.common['Authorization'];
    }
}

export default setAuthToken;